import PortalDocument from "./PortalDocument";
import AbstractContainer from "./AbstractContainer";
import ViewerType from "./DataType";
import Exception from "../../shared/exception/Exception";
import Translate from "../../shared/translation/Translate";
import FunctionHelper from "../../shared/helper/FunctionHelper";

export default class DefaultContainer extends AbstractContainer {
	public clean(): void {
		this.data = undefined;
		this.loaded = false;
	}

	public async loadViewerData(portalDocument: PortalDocument): Promise<any> {
		if (!FunctionHelper.exists(this.data)) {
			throw new Exception(Translate.value("errors.files.corrupt", {ns: "message"}));
		}

		return this.data;
	}

	public async getNumberOfPages(portalDocument: PortalDocument) {
		return 1;
	}

	public getType(): ViewerType {
		return ViewerType.DEFAULT;
	}
}